/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SaveClientPropertyRequest { 
    id?: number;
    brandId: number;
    note?: string;
    blacklisted?: boolean;
    vip?: boolean;
}

